import * as React from 'react'
import { useRouter } from 'next/router'
import styled, { css } from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import * as hooks from '@owl-nest/hooks'

import * as utils from '@boutique/utils'
import * as entity from '@boutique/entities'

type PaginationProps = {
  response: hooks.Response<entity.search.product.Result>
  getPageHref: (page: number) => string
  page?: number
}

const protocol = process.env.NODE_ENV === 'production' ? 'https://' : 'http://'
const domainPrefix =
  process.env.NODE_ENV === 'production' ? (process.env.VERCEL_ENV === 'production' ? 'www.' : '') : ''

export function Pagination({ response, getPageHref, page }: PaginationProps) {
  const router = useRouter()

  if (response.data === undefined) {
    return (
      <LayoutPagination>
        <TextPlaceholder>chargement...</TextPlaceholder>
      </LayoutPagination>
    )
  }

  const domain = router.domainLocales?.[0].domain
  const baseUrl = `${protocol}${domainPrefix}${domain}`

  return (
    <LayoutPagination hideOnMobile={response.data.nbPages <= 1}>
      <plume.Pagination
        linkComponent={({ page, children }) => {
          const href = getHref(page)

          return (
            // NOTE: since these '<a>' are not a 'next/link', we need to pass an absolute url
            <a href={baseUrl + href} onClick={(e) => e.preventDefault()}>
              {children}
            </a>
          )
        }}
        onNavigate={(page) => {
          const href = getHref(page)

          router.push(href, undefined, { shallow: true, locale: false })
        }}
        pageCount={response.data.nbPages ?? 0}
        selectedPage={(page ?? 0) + 1}
      />
    </LayoutPagination>
  )

  function getHref(page: number): string {
    let href = getPageHref(page)

    href = utils.link.addTopAnchorAtHrefEnd(baseUrl, href)
    href = utils.link.removeNextInternalLocale(baseUrl, href)
    return href
  }
}

const LayoutPagination = styled.div<{ hideOnMobile?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 22px 0px 160px;

  @media not screen and ${plume.BREAKPOINTS.TABLET} {
    margin: 60px 0px 10px;

    ${({ hideOnMobile }) => {
      if (hideOnMobile) {
        return css`
          display: none;
        `
      }
    }}
  }
`

const TextPlaceholder = styled.div`
  height: 34px;
  text-align: center;
`
